export default "__VITE_ASSET__DYu1L9bD__"